import React from "react";
import moment from "moment";

/****
  Name: SetVictoryLabels
  Definition:
    Define formatted array of given timeframe.
  Found in files:
    Home.js
    Filtering.js
****/
export function SetVictoryLabels(timeframe, start, end) {
  let startTime, endTime, increment, format;
  start = new Date(start);
  end = new Date(end);

  // Determine date range and correlated variables
  if (timeframe === "CurrentMonth") {
    startTime = moment().subtract(1, "months").startOf("day");
    endTime = moment();
    increment = "days";
    format = "MM/DD";
  } else if (timeframe === "LastMonth") {
    startTime = moment().subtract(1, "months").startOf("month");
    endTime = moment().subtract(1, "months").endOf("month");
    increment = "days";
    format = "MM/DD";
  } else if (timeframe === "CurrentYear") {
    startTime = moment().startOf("year");
    endTime = moment();
    increment = "months";
    format = "MMM";
  } else if (timeframe === "LastYear") {
    startTime = moment().subtract(1, "years").startOf("year");
    endTime = moment().subtract(1, "years").endOf("year");
    increment = "months";
    format = "MMM";
  } else {
    let diffInDays = parseInt(moment(end).diff(start, "days"));
    startTime = moment(start);
    endTime = moment(end);
    if (diffInDays > 31) {
      increment = "months";
      format = "MMM";
    } else {
      increment = "days";
      format = "MM/DD";
    }
  }
  let victoryLabels = [];
  for (let d = startTime; d <= endTime; d = moment(d).add(1, increment))
    victoryLabels.push(moment(d).format(format));

  return { startTime, endTime, increment, format, victoryLabels };
}

/****
  Name: ExportData
  Definition:
    Download CSV of current graph displayed.
  Found in files:
    Home.js
****/
export function ExportData(data) {
  var json = data;
  var fields = Object.keys(json[0]);
  var replacer = function (key, value) {
    return value === null ? "" : value;
  };
  var csv = json.map(function (row) {
    return fields
      .map(function (fieldName) {
        return JSON.stringify(row[fieldName], replacer);
      })
      .join(",");
  });
  csv.unshift(fields.join(",")); // add header column
  csv = csv.join("\r\n");

  var blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, "evolutionDataCSV");
  } else {
    var link = document.createElement("a");
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, "evolutionDataCSV.csv");
    } else if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "evolutionDataCSV.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
